import styled from 'styled-components';

export const StyledStatusSelectWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;
